import Resource from '@/api/core/resource'

class Turno extends Resource {
  constructor () {
    super('turnos')
  }

  obtenerTurnosMedico (medicoId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(medicoId)
        .concat('/turnos-del-dia')
    )
  }

  informeMedico (medicoId, turnoId, data) {
    return this.request.post(
      this.uri
        .concat('/')
        .concat(medicoId)
        .concat('/informe-medico/')
        .concat(turnoId),
      data
    )
  }

  asignarNuevo (data) {
    data.accion = 'asignar'
    return this.request.post(this.uri, data)
  }
}

export default new Turno()
